import React from 'react';
import 'twin.macro';
import Button from '@teetsh/app/src/components/Buttons/Button';
import Tooltip2 from '@teetsh/app/src/components/Tooltip2';
import { PencilIcon } from '@heroicons/react/24/outline';
import { lineClamp } from '@teetsh/app/src/utils/style/lineClamp';

interface TitleWithEditButtonProps {
  title: string;
  onEdit?: () => void;
  isReadOnly?: boolean;
  className?: string;
}

export function TitleWithEditButton({
  title,
  onEdit,
  isReadOnly = false,
  className,
}: TitleWithEditButtonProps) {
  return (
    <div tw="flex items-center gap-x-2 min-w-0 max-w-full">
      <Tooltip2 css={lineClamp(2)} label={title}>
        <h1 tw="text-center min-w-0" className={className}>
          {title}
        </h1>
      </Tooltip2>
      {!isReadOnly && onEdit && (
        <Button
          icon={PencilIcon}
          onClick={onEdit}
          aria-label="Éditer le titre"
          minimal
        />
      )}
    </div>
  );
}
